import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapSelectOption = React.lazy(function () { return import('../../bootstrap-components/components/BTSparkLine'); });
var bootStrapSelectOption = function (props) {
    return (React.createElement(BootStrapSelectOption, __assign({ styleName: props.hasError ? 'danger' : props.styleName }, props)));
};
export var SparkLine = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapSelectOption(props);
            break;
        default:
            componentToDisplay = bootStrapSelectOption(props);
            break;
    }
    return (React.createElement("div", null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
SparkLine.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    color: "#253e56",
    data: [1, 45, 4, 54, 5, 5, 2, 5, 1]
};
//# sourceMappingURL=SparkLine.js.map